import clientConfig from "../config/clientConfig";
const host = clientConfig.apiBaseUrl

export async function getUser() {
    let res = await fetch(host + "/user", {
        method: "GET", credentials: "include"
    });
    if (res.status !== 403) {
        let json = await res.json();
        if (isJSON(json.settings)) {
            json.settings = JSON.parse(json.settings);
        }
        return json;
    } else {
        let json = await res.json();
        return {user: undefined, settings: !isJSON(json.settings) ? json.settings : JSON.parse(json.settings)};
    }
}



export async function getUserDetails(id) {
    let res = await fetch(`${host}/users/${id}/info`, {
        method: "GET", credentials: "include"
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

function isJSON(obj) {
    try {
        JSON.parse(obj);
        return true;
    } catch (e) {
        return false;
    }
}

export async function followUser(userid) {
    let res = await fetch(host + `/users/${userid}/follow`, {
        method: "POST", credentials: "include", headers: {
            'Content-Type': 'application/json',
        }
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function unfollowUser(userid) {
    let res = await fetch(host + `/users/${userid}/unfollow`, {
        method: "POST", credentials: "include", headers: {
            'Content-Type': 'application/json',
        }
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function updateUser(userid, newUser) {
    let res = await fetch(host + "/users/" + userid, {
        method: "PUT", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(newUser)
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}


export async function deleteCurrentUser(userid, password) {
    let res = await fetch(host + "/users/" + userid, {
        method: "DELETE", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({password})
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function deleteUser(userid) {
    let res = await fetch(host + "/users/" + userid, {
        method: "DELETE", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function resendEmailVerification(email) {
    let res = await fetch(host + "/verify/resend", {
        method: "POST", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email})
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function resetPassword(email) {
    let res = await fetch(host + "/users/password/reset", {
        method: "POST", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({email})
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function verifyToken(token) {
    let res = await fetch(host + `/verify/${token}`, {
        method: "GET", credentials: "include", headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function getUserNotifications() {
    let res = await fetch(host + "/users/notifications", {
        method: "GET", credentials: "include"
    });
    if (res.status !== 403) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function markAllNotificationsAsRead() {
    let res = await fetch(host + "/users/notifications/read", {
        method: "PUT", credentials: "include"
    });
    if (res.status !== 403) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function getTeacherCourses(id) {
    let res = await fetch(`${host}/users/${id}/courses/teacher`, {
        method: "GET", credentials: "include"
    });
    if (res.status !== 403) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function getTeacherServices(id) {
    let res = await fetch(`${host}/users/${id}/services/teacher`, {
        method: "GET", credentials: "include"
    });
    if (res.status !== 403) {
        return await res.json();
    } else {
        return undefined;
    }
}




export async function modifyRights(userid, newRole) {
    let res = await fetch(`${host}/users/${userid}/rights`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({newRole: JSON.stringify(newRole)})
    });

    if (res.status !== 500) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function modifyTeacherCourses(userid, courses) {
    let res = await fetch(`${host}/users/${userid}/courses`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({courses})
    });

    if (res.status !== 500) {
        return await res.json();
    } else {
        return undefined;
    }
}
export async function modifyTeacherServices(userid, services) {
    let res = await fetch(`${host}/users/${userid}/services`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({services})
    });

    if (res.status !== 500) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function promoteToAdmin(userid) {
    let res = await fetch(`${host}/users/${userid}/promote/`, {
        method: 'POST',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    });

    if (res.status === 200) {
        return await res.json();
    } else {
        return res.status;
    }
}

export async function getUsers() {
    let res = await fetch(host + "/users", {
        method: "GET", credentials: "include"
    });
    if (res.status !== 403) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function generateJWTToken() {
    let res = await fetch(host + "/generate-token", {
        method: "POST", credentials: "include"
    });
    if (res.status === 200) {
        return await res.json();
    } else {
        return undefined;
    }
}

export async function updatePassword(oldPassword, newPassword, token) {
    try {
        const response = await fetch(host + '/update-password', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            }
            , credentials: "include",
            body: JSON.stringify({oldPassword, newPassword, token}),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error updating password:', error);
        return {error: 'An error occurred while updating the password.'};
    }
}

export async function updateUserDetails(editMode, value) {
    const requestOptions = {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({editMode, value}),
        credentials: 'include', // Send cookies along with the request
    };

    try {
        const response = await fetch(host + "/users/me/profile", requestOptions);
        if (!response.ok) {
            // Handle error response if needed
            const errorData = await response.json();
            throw new Error(errorData.error || 'Failed to update user details.');
        }

        // Parse the JSON response to get the updated user information
        return await response.json();
    } catch (error) {
        // Handle fetch error or other errors
        console.error('Error updating user details:', error.message);
        throw error;
    }
}

export function signUpUser(name, email, password, telegram, telephone, callback) {
    fetch(host + '/sign-up', {
        method: "POST",
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            name: name,
            email: email,
            password: password,
            telegram: telegram,
            telephone: telephone
        })
    })
        .then((response) => {
            return response.status === 200 ? response.json() : response.status
        })
        .then((data) => {
            console.log(data)
            callback(data);
        }).catch((r) => {
        console.log(r);
    });

}

export function loginUser(email, password, callback) {
    fetch(host + '/sign-in', {
        method: "POST",
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email: email,
            password: password
        })
    })
        .then((response) => {
            if (response.status === 200 ) {
                return response.json()

            } else {
                return response.status
            }
        }).then((data) => {
            console.log(data)
            if ( isNaN(data) && data.error) {
                callback(undefined, data.error,);
            } else if (!isNaN(data)) {
                callback(undefined, data)
            } else {
                callback(data, undefined)
            }
        });

}


export function logoutUser(callback) {
    fetch(host + '/logout', {
        method: "POST",
        credentials: "include",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
    }).then((response) => response.json())
        .then((data) => {
            console.log(data)
            if (data.error) {
                callback(undefined, data.error);
            } else {
                callback(data, undefined)
            }
        });
}